import React, { createContext, useState, useContext, useEffect } from 'react';

const ChatContext = createContext();

export const ChatContextProvider = ({ children }) => {
  const [chatData, setChatData] = useState(null);

  useEffect(() => {
    const agentId = sessionStorage.getItem('agentId');
    const agentName = sessionStorage.getItem('agentName');
    const start = sessionStorage.getItem('start');
    const end = sessionStorage.getItem('end');

    if (agentId && agentName && start && end) {
      const data = {
        agentId: agentId,
        name: agentName,
        startTime: Number(start),
        endTime: Number(end),
      };
      setChatData(data);
    }

  }, []);

  return (
    <ChatContext.Provider value={{ chatData, setChatData }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => useContext(ChatContext);
